import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { ScreenReaderOnly } from '../../styles/a11y_helpers';
import styled from '../../styles/styled';
import theme from '../../styles/theme';
const Ring = styled.div({
    display: 'inline-block',
    position: 'relative',
}, ({ size }) => {
    return {
        width: size,
        height: size,
    };
});
const Item = styled.div({
    boxSizing: 'border-box',
    display: 'block',
    position: 'absolute',
    borderRadius: '50%',
    animation: `${theme.keyframes.rotate} 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite`,
}, ({ delay, size, color }) => {
    return {
        border: `6px solid ${color}`,
        borderColor: `${color} transparent transparent transparent`,
        animationDelay: delay,
        width: size,
        height: size,
    };
});
export const Spinner = ({ color = theme.colors.azure, size = '3.125rem' }) => {
    return (_jsxs(Ring, { size: size, role: "status", "aria-busy": "true", "aria-live": "polite", "data-testid": "spinner-animation", children: [_jsx(ScreenReaderOnly, { children: "Loading" }), _jsx(Item, { delay: "0s", color: color, size: size }), _jsx(Item, { delay: "-0.45s", color: color, size: size }), _jsx(Item, { delay: "-0.3s", color: color, size: size }), _jsx(Item, { delay: "-0.15s", color: color, size: size })] }));
};
//# sourceMappingURL=spinner.js.map